import * as React from 'react';
import { Box, Typography } from '@material-ui/core';
import NotListedLocationIcon from '@material-ui/icons/NotListedLocation';
import { makeStyles } from '@material-ui/styles';
import CancelButton from '../common/Button/CancelButton';
import { useHistory } from 'react-router-dom';
import HomeIcon from '@material-ui/icons/Home';

const useStyles = makeStyles({
    root: {
        padding: '50px 0px 0px',
        textAlign: 'center'
    },
    icon: {
        marginRight: '10px'
    },
    homeButton: {
        marginTop: '100px'
    }
})
const NotFound: React.FC = () => {
    const classes = useStyles();
	const history = useHistory();

    return (
        <Box className={classes.root}>
            <Typography gutterBottom variant="h3">
                <NotListedLocationIcon className={classes.icon} fontSize='inherit' />
                Page Not Found
            </Typography>
            <Typography variant="h6">
                The page you are looking for does not exist.
            </Typography>
            <CancelButton className={classes.homeButton} icon={<HomeIcon />} message='Return Home' onClick={() => history.push('/')} />
        </Box>
    );
};
export default NotFound;
